"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ExportCompetencyAssignmentsCsvResponse () {
        return ExportCompetencyAssignmentsCsvResponse;
    },
    get ListAssignmentHistoryResponse () {
        return ListAssignmentHistoryResponse;
    },
    get ListCompanyCompetencyAssignmentsResponse () {
        return ListCompanyCompetencyAssignmentsResponse;
    },
    get ListCompetencyAssignmentsResponse () {
        return ListCompetencyAssignmentsResponse;
    },
    get ListTeamCompetencyAssignmentsResponse () {
        return ListTeamCompetencyAssignmentsResponse;
    },
    get UpdateCurrentLevelResponse () {
        return UpdateCurrentLevelResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _responsehelpers = require("../helpers/response-helpers");
const UserActionResponse = _zod.z.object({
    user_id: _responsehelpers.ResponseObjectId,
    time_stamp: _zod.z.union([
        _zod.z.date(),
        _zod.z.string()
    ])
});
const Level = _zod.z.object({
    rank: _zod.z.number().int(),
    name: _zod.z.string(),
    description: _zod.z.string()
});
const CompetencyDictEntry = _zod.z.object({
    name: _zod.z.string(),
    description: _zod.z.string(),
    is_company_wide: _zod.z.boolean(),
    levels: _zod.z.array(Level)
});
const RoleDictEntry = _zod.z.object({
    name: _zod.z.string()
});
const UserDictEntry = _zod.z.object({
    name: _zod.z.string()
});
const CompetencyDict = _zod.z.record(_zod.z.string(), CompetencyDictEntry);
const RoleDict = _zod.z.record(_zod.z.string(), RoleDictEntry);
const CompetencyOptionsDict = _zod.z.record(_zod.z.string(), _zod.z.object({
    name: _zod.z.string()
}));
const UserDict = _zod.z.record(_zod.z.string(), UserDictEntry);
const CompetencyAssignmentUserDictEntry = _zod.z.object({
    name: _zod.z.string(),
    // the assignee's own role (from the "Role" custom field), resolved server-side; null when unset.
    role_name: _zod.z.string().nullable()
});
const CompetencyAssignmentUserDict = _zod.z.record(_zod.z.string(), CompetencyAssignmentUserDictEntry);
const CompetencyAssignmentItem = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    company_id: _responsehelpers.ResponseObjectId,
    competency_id: _responsehelpers.ResponseObjectId,
    user_id: _responsehelpers.ResponseObjectId,
    source: _models.CompetencyAssignmentSourceSchema,
    role_id: _responsehelpers.ResponseObjectId.nullable(),
    expected_level: _zod.z.number().int().nullable(),
    current_level: _zod.z.number().int().nullable(),
    status: _models.CompetencyAssignmentStatusSchema,
    created: UserActionResponse,
    updated: UserActionResponse
});
const ListCompetencyAssignmentsResponse = _zod.z.object({
    assignments: _zod.z.array(CompetencyAssignmentItem),
    competencies: CompetencyDict,
    totalCount: _zod.z.number().int()
});
const ListTeamCompetencyAssignmentsResponse = _zod.z.object({
    assignments: _zod.z.array(CompetencyAssignmentItem),
    competencies: CompetencyDict,
    // Active competencies — the Competency filter's option list.
    competencyOptions: CompetencyOptionsDict,
    users: CompetencyAssignmentUserDict,
    // distinct roles held by the team (the assignees' OWN roles) — the Role filter's option list.
    roles: RoleDict,
    totalCount: _zod.z.number().int()
});
const ListCompanyCompetencyAssignmentsResponse = _zod.z.object({
    assignments: _zod.z.array(CompetencyAssignmentItem),
    // Resolution dict covering every competency id referenced by returned rows (may include archived).
    competencies: CompetencyDict,
    // Active competencies — the Competency filter's option list.
    competencyOptions: CompetencyOptionsDict,
    users: CompetencyAssignmentUserDict,
    // Resolution dict covering every role id referenced by returned rows (may include archived).
    roles: RoleDict,
    // Active-only company roles (held or not) — the Role filter's dropdown option list.
    roleOptions: RoleDict,
    totalCount: _zod.z.number().int()
});
const historyEntryBase = {
    _id: _responsehelpers.ResponseObjectId,
    competency_assignment_id: _responsehelpers.ResponseObjectId,
    competency_id: _responsehelpers.ResponseObjectId,
    user_id: _responsehelpers.ResponseObjectId,
    effective_date: _zod.z.union([
        _zod.z.date(),
        _zod.z.string()
    ]),
    created: UserActionResponse
};
const historyLevelValue = _zod.z.number().int().nullable();
const HistoryEntry = _zod.z.discriminatedUnion("event_type", [
    _zod.z.object({
        ...historyEntryBase,
        event_type: _zod.z.literal("level_update"),
        previous_level: historyLevelValue,
        new_level: historyLevelValue,
        source: _models.CompetencyLevelChangeSourceSchema,
        role_id: _zod.z.null()
    }),
    _zod.z.object({
        ...historyEntryBase,
        event_type: _zod.z.literal("expected_level_update"),
        previous_level: historyLevelValue,
        new_level: historyLevelValue,
        source: _zod.z.null(),
        role_id: _zod.z.null()
    }),
    _zod.z.object({
        ...historyEntryBase,
        event_type: _zod.z.literal("role_assignment"),
        previous_level: _zod.z.null(),
        new_level: _zod.z.null(),
        source: _zod.z.null(),
        // resolve against the `roles` dict for the role name
        role_id: _responsehelpers.ResponseObjectId
    }),
    _zod.z.object({
        ...historyEntryBase,
        event_type: _zod.z.literal("role_unassignment"),
        previous_level: _zod.z.null(),
        new_level: _zod.z.null(),
        source: _zod.z.null(),
        // resolve against the `roles` dict for the role name (the role the user left)
        role_id: _responsehelpers.ResponseObjectId
    }),
    _zod.z.object({
        ...historyEntryBase,
        event_type: _zod.z.literal("role_competency_removal"),
        previous_level: _zod.z.null(),
        new_level: _zod.z.null(),
        source: _zod.z.null(),
        // resolve against the `roles` dict for the role name (the role it was removed from)
        role_id: _responsehelpers.ResponseObjectId
    }),
    _zod.z.object({
        ...historyEntryBase,
        event_type: _zod.z.literal("company_wide_assignment"),
        previous_level: _zod.z.null(),
        new_level: _zod.z.null(),
        source: _zod.z.null(),
        role_id: _zod.z.null()
    })
]);
const ListAssignmentHistoryResponse = _zod.z.object({
    history: _zod.z.array(HistoryEntry),
    // `users` keyed by each entry's `created.user_id` (the actor who made the change).
    users: UserDict,
    // `roles` keyed by `role_id` for `role_assignment` / `role_unassignment` events.
    roles: RoleDict,
    totalCount: _zod.z.number().int()
});
const UpdateCurrentLevelResponse = _zod.z.object({
    assignment: CompetencyAssignmentItem
});
const ExportCompetencyAssignmentsCsvResponse = _zod.z.object({
    taskId: _zod.z.string()
});
